module.exports = __webpack_public_path__ + "img/evaluation_background.c3cfce83.png";